import React from 'react'

const parivacy = () => {
  return (
    <div style={{fontSize: '2.5rem'}}>parivacy</div>
  )
}

export default parivacy